"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stampduty = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var StampdutyDesktop_1 = require("@/pages/stampduty/components/StampdutyDesktop");
var StampdutyMobile_1 = require("@/pages/stampduty/components/StampdutyMobile");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var Breadcrumb_1 = require("@/pages/search/components/Breadcrumb");
var mapStateToProps = function (state) { return ({
    headerSection: state.headerSection,
    contentSection: state.contentSection,
    footerSection: state.footerSection,
}); };
var mapDispatchToProps = function () { return ({}); };
exports.stampduty = function (props) {
    var breadcrumbClasses = 'l-container l-container--lr u-mobile-hidden l-pad-top l-pad--2 t--darker';
    var attr = {};
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { className: "l-pad-top" },
            React.createElement("div", { id: "stampduty-page", className: "l-container l-container--lr" },
                React.createElement("div", { className: "l-container__main" },
                    React.createElement("div", { className: breadcrumbClasses },
                        React.createElement(Breadcrumb_1.default, null)),
                    React.createElement("div", { className: "l-pad" },
                        React.createElement("div", { className: "c-page-header__body" },
                            React.createElement("div", { className: "c-page-header__title" }, props.headerSection.translate.title),
                            React.createElement("div", { className: "c-page-header__caption" }, props.headerSection.translate.paragraph))),
                    React.createElement("div", { className: "c-stampduty c-stampduty--sm l-pad l-pad--2" },
                        React.createElement("div", { className: "u-mobile-hidden" }, StampdutyDesktop_1.renderDesktop(props)),
                        React.createElement("div", { className: "u-mobile-only" }, StampdutyMobile_1.renderMobile(props))),
                    React.createElement("div", { className: "l-pad l-pad--4" },
                        React.createElement("div", { className: "u-sm l-pad" }, props.footerSection.translate.lastUpdatedDate),
                        React.createElement("div", { className: "u-sm", dangerouslySetInnerHTML: { __html: props.footerSection.translate.disclaimer } }))))),
        React.createElement(ServerSideSchema_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.stampduty);
